import {
  DeleteFirmwaresOperationRequest,
  DeleteFirmwaresRequest,
  DownloadFirmwareS3Request,
  FirmwareS3Request,
  ReadFirmwaresRequest,
  ReadFirmwaresByDeviceTypeIdRequest,
  CreateFirmwareRequest,
  ReadFirmwareRequest,
  UploadFirmwareWithUiFormRequest,
} from '@openapi';
import { Firmware, Rule } from '@services/types';
import { getDevicesApi, getFirmwaresApi } from './configuration';

const firmwares = {
  getFirmwares: (requestParameters?: ReadFirmwaresRequest) => {
    return getFirmwaresApi().readFirmwares(requestParameters);
  },
  getFirmwaresById: (requestParameters: ReadFirmwareRequest['id']) => {
    return getFirmwaresApi().readFirmware({ id: requestParameters });
  },
  createFirmware: (firmware: CreateFirmwareRequest) => {
    return getFirmwaresApi().createFirmware({ file: firmware.file, enableInvalidation: firmware.enableInvalidation });
  },
  createS3FormFirmware: (firmware: UploadFirmwareWithUiFormRequest) => {
    return getFirmwaresApi().uploadFirmwareWithUiForm(firmware);
  },
  deleteFirmware: (firmwareId: Firmware['id']) => {
    return getFirmwaresApi().deleteFirmware({ id: firmwareId });
  },
  deployFirmware: (firmwareId: Firmware['id'], upgradeRuleIds: Rule['id'][]) => {
    return getFirmwaresApi().deployFirmware({ id: firmwareId, firmwareDeploymentRequest: { upgradeRuleIds } });
  },
  deployFirmwareS3: (firmware: DownloadFirmwareS3Request) => {
    return getFirmwaresApi().downloadFirmwareS3({
      firmwareS3Request: firmware.firmwareS3Request,
      enableInvalidation: firmware.enableInvalidation,
    });
  },
  getUnusedFirmwares: () => {
    return getFirmwaresApi().readUnusedFirmware();
  },
  deleteUnusedFirmware: (requestParameters: DeleteFirmwaresRequest) => {
    return getFirmwaresApi().deleteFirmwares({ deleteFirmwaresRequest: requestParameters });
  },
  getFirmwaresDeviceId: (requestParameters: ReadFirmwaresByDeviceTypeIdRequest) => {
    return getFirmwaresApi().readFirmwaresByDeviceTypeId({ deviceTypeId: requestParameters.deviceTypeId });
  },
};

export default firmwares;
